import { personalAccessTokensApi } from './personalAccessTokensApi';

// OAuth consent page + "Connected apps" API (backend: /api/v2/oauth/*,
// session-JWT authenticated). Injected into the existing personalAccessTokensApi
// slice - same /api/v2 base URL and Authorization header - so no extra store
// wiring (reducer/middleware) is needed.
export const oauthApi = personalAccessTokensApi
  .enhanceEndpoints({ addTagTypes: ['ConnectedApps'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getOAuthRequest: builder.query({
        query: (requestId) => ({
          url: `/oauth/requests/${encodeURIComponent(requestId)}`,
          method: 'GET',
        }),
        keepUnusedDataFor: 0,
      }),
      approveOAuthRequest: builder.mutation({
        query: ({ requestId, stepUp }) => ({
          url: `/oauth/requests/${encodeURIComponent(requestId)}/approve`,
          method: 'POST',
          body: { stepUp },
        }),
        invalidatesTags: ['ConnectedApps'],
      }),
      denyOAuthRequest: builder.mutation({
        query: (requestId) => ({
          url: `/oauth/requests/${encodeURIComponent(requestId)}/deny`,
          method: 'POST',
          body: {},
        }),
      }),
      getMcpConnectionInfo: builder.query({
        query: () => ({ url: '/oauth/connection-info', method: 'GET' }),
        keepUnusedDataFor: 3600,
      }),
      listConnectedApps: builder.query({
        query: () => ({ url: '/oauth/grants', method: 'GET' }),
        providesTags: ['ConnectedApps'],
      }),
      revokeConnectedApp: builder.mutation({
        query: (grantId) => ({
          url: `/oauth/grants/${encodeURIComponent(grantId)}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['ConnectedApps'],
      }),
    }),
  });

export const {
  useGetMcpConnectionInfoQuery,
  useGetOAuthRequestQuery,
  useApproveOAuthRequestMutation,
  useDenyOAuthRequestMutation,
  useListConnectedAppsQuery,
  useRevokeConnectedAppMutation,
} = oauthApi;
